import { SOURCE_VALUES } from "../constants/sourceOptions";

const SOURCE_ALIASES = {
  LINKEDIN: "LINKEDIN",
  LINKED_IN: "LINKEDIN",
  LI: "LINKEDIN",
  MONSTER: "MONSTER",
  MONSTER_COM: "MONSTER",
  INDEED: "INDEED",
  DICE: "DICE",
  GLASSDOOR: "GLASS_DOOR",
  GLASS_DOOR: "GLASS_DOOR",
  CAREERBUILDER: "CAREER_BUILDER",
  CAREER_BUILDER: "CAREER_BUILDER",
  STACKOVERFLOW: "STACK_OVERFLOW",
  STACK_OVERFLOW: "STACK_OVERFLOW",
  ZIPRECRUITER: "ZIPRECRUITER",
  WEBSITE: "WEBSITE",
  WEB: "WEBSITE",
  SITE: "WEBSITE",
  INTERNAL: "INTERNAL",
  EMAIL: "EMAIL_MARKETING",
  EMAIL_MARKETING: "EMAIL_MARKETING",
  NEWSLETTER: "EMAIL_MARKETING",
};

const SOURCE_PARAM_KEYS = ["source", "utm_source", "utm_medium"];
export const DEFAULT_SOURCE = "WEBSITE";

const normalizeToken = (value) =>
  value
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

export const resolveSourceValue = (rawValue) => {
  if (!rawValue) {
    return "";
  }

  const normalized = normalizeToken(rawValue);
  if (!normalized) {
    return "";
  }

  if (SOURCE_VALUES.includes(normalized)) {
    return normalized;
  }

  if (SOURCE_ALIASES[normalized]) {
    return SOURCE_ALIASES[normalized];
  }

  const matchedValue = SOURCE_VALUES.find((sourceValue) =>
    normalized.includes(sourceValue)
  );
  if (matchedValue) {
    return matchedValue;
  }

  const matchedAlias = Object.entries(SOURCE_ALIASES).find(([alias]) =>
    normalized.includes(alias)
  );
  return matchedAlias ? matchedAlias[1] : "";
};

export const getSourceFromUrl = (search = "") => {
  const params = new URLSearchParams(search);

  for (const key of SOURCE_PARAM_KEYS) {
    const resolved = resolveSourceValue(params.get(key));
    if (resolved) {
      return resolved;
    }
  }

  return DEFAULT_SOURCE;
};
